import Select from '../select';
import Input from '../input';
import {ButtonGroup, Button} from '../button';
import {_$, getRestProps} from '../utils';
import Icon from '../icon';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {
    total, current, limit, limits, 
    className, showTotal, showGoto,
    counts, size, noBorder, simple,
    showLimits
} = self.get();

if (!total) return hc(' pagination ')

const classNameObj = {
    'k-pagination': true,
    [className]: className,
    [`k-${size}`]: size !== 'default',
    ['k-no-border']: noBorder,
    ['k-simple']: simple,
};

let type = 'default';
if (noBorder || simple) {
    type = 'none';
}

const totalPages = (Math.ceil(total / limit)) || 0;

const paginationButton = function(page) {
    return (
        h(Button, {
        'type': function() {try {return (type )} catch(e) {_e(e)}}.call($this),
        'size': function() {try {return (size )} catch(e) {_e(e)}}.call($this),
        'icon': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
        'value': function() {try {return (page )} catch(e) {_e(e)}}.call($this),
        'children': function() {try {return (page )} catch(e) {_e(e)}}.call($this),
        '_context': $this
    })
    );
};

const paginationDot = function(callback) {
    return h(Button, {
        'type': function() {try {return (type )} catch(e) {_e(e)}}.call($this),
        'size': function() {try {return (size )} catch(e) {_e(e)}}.call($this),
        'icon': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
        'className': 'k-ellipsis',
        'children': '...',
        '_context': $this,
        'ev-click': function() {try {return (callback )} catch(e) {_e(e)}}.call($this)
    })
};

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this)
    }, [
        h(ButtonGroup, {
            'checkType': 'radio',
            'children': [
                h(Button, {
                    'icon': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                    'size': function() {try {return (size )} catch(e) {_e(e)}}.call($this),
                    'disabled': function() {try {return (current <= 1 )} catch(e) {_e(e)}}.call($this),
                    'type': function() {try {return (type )} catch(e) {_e(e)}}.call($this),
                    'children': h(Icon, {
                        'className': 'ion-ios-arrow-left',
                        '_context': $this
                    }),
                    '_context': $this,
                    'ev-click': function() {try {return (self.prev )} catch(e) {_e(e)}}.call($this)
                }),
                function() {try {return (do {
                let items = [];
                let minCount = Math.ceil(counts / 2);
                let maxCount = totalPages - minCount;
                let prevPage = current - 1;
                let nextPage = current + 1;

                if (!simple) {
                    if (totalPages > counts) {
                        if (current <= minCount) {
                            const max = counts - 2;
                            for (let i = 1; i <= max; i++) {
                                items.push(paginationButton(i));
                            }
                            items.push(paginationDot(self.fastNext));
                            items.push(paginationButton(totalPages));
                        } else if (current > minCount && current <= maxCount) {
                            items.push(paginationButton(1));
                            items.push(paginationDot(self.fastPrev));

                            const midCount = counts - 4;
                            const mid = Math.floor(midCount / 2);
                            const min = current - mid;
                            const max = midCount % 2 === 1 ? current + mid : current + mid - 1;
                            for (let i = min; i <= max; i++) {
                                items.push(paginationButton(i));
                            }

                            items.push(paginationDot(self.fastNext));
                            items.push(paginationButton(totalPages));
                        } else {
                            items.push(paginationButton(1));
                            items.push(paginationDot(self.fastPrev));

                            const min = totalPages - counts + 3;
                            for (let i = min; i <= totalPages; i++) {
                                items.push(paginationButton(i));
                            }
                        }
                    } else {
                        for (let i = 1; i <= totalPages; i++) {
                            items.push(paginationButton(i));
                        }
                    }
                } else {
                    items = [
                        h(Input, {
                    'size': function() {try {return (size === 'mini' || size === 'small' ? 'mini' : 'small' )} catch(e) {_e(e)}}.call($this),
                    'autoWidth': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                    'value': function() {try {return (current )} catch(e) {_e(e)}}.call($this),
                    '_context': $this,
                    'ev-change': function() {try {return (self._goto )} catch(e) {_e(e)}}.call($this)
                }),
                        h('span', null, [
                    ' / ',
                    function() {try {return (totalPages )} catch(e) {_e(e)}}.call($this)
                ], 'k-text'),
                    ];
                }

                items;
            } 
        )} catch(e) {_e(e)}}.call($this),
                h(Button, {
                    'icon': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                    'size': function() {try {return (size )} catch(e) {_e(e)}}.call($this),
                    'disabled': function() {try {return (current >= totalPages )} catch(e) {_e(e)}}.call($this),
                    'type': function() {try {return (type )} catch(e) {_e(e)}}.call($this),
                    'children': h(Icon, {
                        'className': 'ion-ios-arrow-right',
                        '_context': $this
                    }),
                    '_context': $this,
                    'ev-click': function() {try {return (self.next )} catch(e) {_e(e)}}.call($this)
                })
            ],
            '_context': $this,
            'value': _getModel(self, 'current'),
            'ev-$change:value': function(__c, __n) { _setModel(self, 'current', __n, $this) }
        }),
        function() {try {return (!simple )} catch(e) {_e(e)}}.call($this) ?
            [
                function() {try {return (showLimits )} catch(e) {_e(e)}}.call($this) ?
                    h('div', null, h(Select, {
                        'allowUnmatch': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                        'data': function() {try {return (limits.map(item => {
                    return {'value': item, 'label': _$('{n} 条 / 页', {n: item})};
                }) )} catch(e) {_e(e)}}.call($this),
                        'size': function() {try {return (size )} catch(e) {_e(e)}}.call($this),
                        '_context': $this,
                        'value': _getModel(self, 'limit'),
                        'ev-$change:value': function(__c, __n) { _setModel(self, 'limit', __n, $this) }
                    }), 'k-limits') :
                    undefined,
                function() {try {return (showGoto )} catch(e) {_e(e)}}.call($this) ?
                    h('div', null, [
                        h('span', null, function() {try {return (_$('跳至') )} catch(e) {_e(e)}}.call($this), 'c-middle'),
                        h(Input, {
                            'size': function() {try {return (size )} catch(e) {_e(e)}}.call($this),
                            'value': function() {try {return (current )} catch(e) {_e(e)}}.call($this),
                            '_context': $this,
                            'ev-change': function() {try {return (self._goto )} catch(e) {_e(e)}}.call($this)
                        }),
                        h('span', null, function() {try {return (_$('页') )} catch(e) {_e(e)}}.call($this), 'c-middle')
                    ], 'k-goto') :
                    undefined,
                function() {try {return (showTotal )} catch(e) {_e(e)}}.call($this) ?
                    h('div', null, function() {try {return (_$('共 {n} 条', {n: total}) )} catch(e) {_e(e)}}.call($this), 'k-total') :
                    undefined
            ] :
            undefined
    ], _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}